import api from '@/utils/axios';

function assertSuccess(response, fallbackMessage) {
  if (!response.data?.success) {
    throw new Error(response.data?.error?.message || fallbackMessage);
  }
  return response.data;
}

export async function fetchDriversBootstrap(token) {
  const response = await api.post('drivers/bootstrap', { token });
  if (!response.data?.success) {
    throw new Error(response.data?.error?.message || 'Failed to load app bootstrap');
  }
  return {
    data: response.data.data,
    meta: response.data.meta || {}
  };
}

export async function fetchDriversList(payload = {}) {
  const response = await api.post('drivers/list', payload);
  const data = assertSuccess(response, 'Failed to load drivers');
  return {
    data: data.data || {},
    meta: data.meta || {}
  };
}

export async function fetchInactiveList(payload = {}) {
  const response = await api.post('inactive/list', payload);
  const data = assertSuccess(response, 'Failed to load inactive drivers');
  return {
    data: data.data || {},
    meta: data.meta || {}
  };
}

export async function fetchDriver(driverId) {
  const token = localStorage.getItem('srToken');
  const response = await api.post('drivers/get', { token, driverId });
  const data = assertSuccess(response, 'Failed to load driver');
  return {
    record: data.data?.record || null,
    history: data.data?.history || []
  };
}

export async function saveDriver({ driverId, payload, expectedLastModified }) {
  const token = localStorage.getItem('srToken');
  const response = await api.post('drivers/save', {
    token,
    driverId,
    payload,
    expectedLastModified
  });
  if (response.status === 409 || response.data?.error?.code === 'conflict.stale') {
    const err = new Error(response.data?.error?.message || 'Record was updated by someone else.');
    err.code = 'CONFLICT';
    err.fresh = response.data?.data?.fresh || null;
    throw err;
  }
  const data = assertSuccess(response, 'Failed to save driver');
  return data.data || {};
}

export async function quickUpdateDriver({ driverId, fields }) {
  const token = localStorage.getItem('srToken');
  const response = await api.post('drivers/quickUpdate', { token, driverId, fields });
  const data = assertSuccess(response, 'Failed to update driver');
  return data.data || {};
}

export async function quickUpdateInactive({ driverId, fields }) {
  const token = localStorage.getItem('srToken');
  const response = await api.post('inactive/quickUpdate', { token, driverId, fields });
  const data = assertSuccess(response, 'Failed to update inactive driver');
  return data.data || {};
}

export async function terminateDriver({ driverId, payload }) {
  const token = localStorage.getItem('srToken');
  const response = await api.post('drivers/terminate', { token, driverId, payload });
  const data = assertSuccess(response, 'Failed to terminate driver');
  return data.data || {};
}

export async function rehireDriver({ driverId, payload }) {
  const token = localStorage.getItem('srToken');
  const response = await api.post('drivers/rehire', { token, driverId, payload });
  const data = assertSuccess(response, 'Failed to rehire driver');
  return data.data || {};
}
